// Single source of truth for "which graphic owns which Maestro caption".
// Broker calls used to hardcode `layer: "gfx_PermScore"` inside every
// sendXGraphicUpdate; if a caption ever moved to a different graphic
// preset every one of those call sites had to be updated in lockstep.
// Callers now resolve the layer by caption name via getGraphicForCaption,
// so adding/relocating a caption only touches this file.

const DEFAULT_GRAPHIC = "gfx_PermScore";

export const CAPTION_GRAPHIC_MAP = {
  // gfx_PermScore (persistent clock + score graphic)
  Main: "gfx_PermScore",
  Cards: "gfx_PermScore",
  GoalScorer: "gfx_PermScore",
  AdditionalTime: "gfx_PermScore",
  AttackingThreat: "gfx_PermScore",
  FreeText: "gfx_PermScore",
  Sponsor: "gfx_PermScore",
  Sponsor_EAFC: "gfx_PermScore",
  Sponsor_HUBLOT: "gfx_PermScore",
  Sponsor_NRFR: "gfx_PermScore",
  MatchStats: "gfx_PermScore",
  Substitution: "gfx_PermScore",

  // gfx_LF_Substitution (lower-frame substitution graphic)
  SubstitutionLF: "gfx_LF_Substitution",
};

export function getGraphicForCaption(captionName) {
  return CAPTION_GRAPHIC_MAP[captionName] || DEFAULT_GRAPHIC;
}
